import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

import { AppService } from '../../app.service';
import { AuthService } from '../../pages/auth/auth.service';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  standalone: false,
})
export class FooterComponent implements OnInit {
  branchName: string;

  constructor(
    private appService: AppService,
    private authService: AuthService
  ) {}

  ngOnInit() {
    this.authService.subscribeAuthData().subscribe((authData) => {
      if (authData.isLoggedIn && !this.branchName) {
        this.getBranch();
      } else {
        this.branchName = null;
      }
    });
  }

  getBranch() {
    this.appService.getBranch().subscribe((response) => {
      this.branchName = response['data']['branch_name'];
    });
  }
}
